export function getTimestampInSeconds() {
  return Math.round(new Date().getTime() / 1000);
}
